/* eslint-disable */ 
import React, { Component } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { divisionEventPowerPointsFilter } from '../../../utils/functions';
import { DIVISIONS,EventPowerPointHeaders } from '../../../utils/constants';
import  Navwrapper  from '../../layout/Navigation';
import Footer from '../../layout/Footer';
import { getEventPowerPointsBySeasonEvent } from '../api'
import { exportCSV, tableOptions} from '../common'
//getEventPowerPointsBySeasonEvent
export default class EventPowerPointsPage extends Component {

  constructor(props) {    super(props);
    const { match } = this.props
    this.state = {      
      eventPowerPointsAll:[],
      seasonId:match.params.seasonId,
      eventId:match.params.eventId,
      tournamentText: match.params.eventName,
      seasonName: match.params.seasonName
    };
  }

  componentDidMount() {
    const _this = this
     
    getEventPowerPointsBySeasonEvent(_this.state.seasonId,_this.state.eventId).then(function(response) {
      const eventPowerPoints = response.data 
      _this.setState({eventPowerPointsAll: eventPowerPoints})    
    }) 
  }      

  DisplayNoPointsAwardedSection() {

    const noPointsDivStyle = {
      display: 'flex',
      justifyContent: 'center'
    };    

      return (
        <div class="col-md-6 col-md-offset-3"  >
        <div style={noPointsDivStyle}>                    
        <b>No Power Points Awarded</b>
        </div>
        <br/>
        <hr width="50%"></hr>
        <div style={noPointsDivStyle}>
        PLEASE NOTE: This message is displayed because either:<br/>
        </div>
        <br/>
        <div style={noPointsDivStyle}>
        1) the power points have not yet been entered into the system<br/>
        </div>
        <div style={noPointsDivStyle}>
        or<br/>
        </div>
        <div style={noPointsDivStyle}>
        2) there were an insufficient number of eligible schools competing<br/>
        </div>
        <div style={noPointsDivStyle}>
        to qualify for power points.<br/>
        </div>
        <hr width="50%"></hr>
        </div>          
      );
  }

  render() {
  const _this = this
  const EventPowerPointsAll = _this.state.eventPowerPointsAll
  var menDivEventPowerPoints = EventPowerPointsAll
                      .filter((powerPoints) => divisionEventPowerPointsFilter(powerPoints, DIVISIONS.MENDIVISION));  
  var womenDivEventPowerPoints = EventPowerPointsAll
                      .filter((powerPoints) => divisionEventPowerPointsFilter(powerPoints, DIVISIONS.WOMENDIVISION));  
  var isLowSchoolCountMen = (menDivEventPowerPoints.length > 0) ? menDivEventPowerPoints[0].isLowSchoolCount : false;
  var isLowSchoolCountWomen = (womenDivEventPowerPoints.length > 0) ? womenDivEventPowerPoints[0].isLowSchoolCount : false;
  if (isLowSchoolCountMen) {
    menDivEventPowerPoints= [];
  }
  if (isLowSchoolCountWomen) {
    isLowSchoolCountWomen=true;
    womenDivEventPowerPoints=[];
  }

  return (
    <div>
      <Navwrapper />
      <div className="container-fluid">
        <div className="pageHeading" >
            <h4>{_this.state.seasonName}</h4>
              <h4 >
                      {_this.state.tournamentText} Tournament
                      Power Points
              </h4>
        </div>      

        <Tabs defaultActiveKey={1} id="event-powerPoints-tabs">
            <Tab eventKey={1} title="MEN">           
                <BootstrapTable 
                  data={menDivEventPowerPoints} 
                  striped 
                  hover
                  options={tableOptions} 
                  // options={{ hideSizePerPage: false }}
                  pagination               
                >
                    <TableHeaderColumn          
                      dataField="Id" 
                      isKey 
                      dataAlign="right" 
                      dataSort 
                      data-Visible="false"               
                      hidden                 
                    >ID
                    </TableHeaderColumn>
                    <TableHeaderColumn dataField="pos" dataSort width="2%" >R#
                    </TableHeaderColumn>
                    <TableHeaderColumn 
                      dataField="teamName" 
                      dataSort  
                      width="15%" 
                    >TEAM NAME
                    </TableHeaderColumn>   
                    <TableHeaderColumn dataField="base" dataAlign="right"  width="2%" >base
                    </TableHeaderColumn>
                    <TableHeaderColumn dataField="tms" dataAlign="right"  width="2%" >tms
                    </TableHeaderColumn>
                    <TableHeaderColumn dataField="total" dataAlign="right"  width="2%" >Total
                    </TableHeaderColumn>                  
                </BootstrapTable>
                { isLowSchoolCountMen &&   this.DisplayNoPointsAwardedSection() }  
                { !isLowSchoolCountMen && exportCSV(menDivEventPowerPoints,EventPowerPointHeaders,'MenDivEventPowerPoints - '+ _this.state.tournamentText +'.csv') }
            </Tab>
          <Tab eventKey={2} title="WOMEN">
            <BootstrapTable 
              data={womenDivEventPowerPoints} 
              striped 
              hover
              options={tableOptions} 
              // options={{ hideSizePerPage: false }} 
              pagination 
            >
              <TableHeaderColumn          
                dataField="Id" 
                isKey 
                dataAlign="right" 
                dataSort 
                data-Visible="false"               
                hidden                 
              >ID
              </TableHeaderColumn>
              <TableHeaderColumn dataField="pos" dataSort width="2%" >R#
              </TableHeaderColumn>
              <TableHeaderColumn 
                dataField="teamName" 
                dataSort  
                width="15%" 
              >TEAM NAME
              </TableHeaderColumn>    
              <TableHeaderColumn dataField="base" dataAlign="right"  width="2%" >base
              </TableHeaderColumn>
              <TableHeaderColumn dataField="tms" dataAlign="right"  width="2%" >tms
              </TableHeaderColumn>
              <TableHeaderColumn dataField="total" dataAlign="right"  width="2%" >Total
              </TableHeaderColumn>                                     
            </BootstrapTable>
            { isLowSchoolCountWomen &&   this.DisplayNoPointsAwardedSection() }  
            { !isLowSchoolCountWomen && exportCSV(womenDivEventPowerPoints,EventPowerPointHeaders,'WomenDivEventPowerPoints - '+ _this.state.tournamentText +'.csv') }
          </Tab>
        </Tabs>
      </div>
      <Footer />
    </div>    
  ); }                      

}


// WEBPACK FOOTER //
// ./src/components/pages/eventPowerPoints/index.js